<template>
  <div class="home-cooperate">
    <div class="container">
      <div>
        <div class="home-cooperate-title">{{ $t("home.cooperate") }}</div>
      </div>
      <div class="home-cooperate-line"></div>

      <div class="home-cooperate-list">
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_1.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_2.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_3.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_4.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_5.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_6.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_7.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_8.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_9.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_10.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_11.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_12.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_13.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_14.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_33.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_34.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_15.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_16.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_17.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_18.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_19.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_20.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_21.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_22.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_23.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_24.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_25.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_26.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_27.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_28.svg"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_29.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_30.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_31.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_32.jpg"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_35.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_36.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_37.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_38.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_39.png"></div>
      </div>

    </div>
  </div>

</template>

<script>

export default {
  name: 'HelloWorld',
  props: {

  },
  components: {

  },
  data() {
    return {
      newsList:'http://localhost/PWmat-server/cms/public/api/articles?page=1&pagesize=4',
      news:'http://localhost/PWmat-server/cms/public/api/pages/1'
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .home-cooperate{
    margin-top: 90px;
  }
  .home-cooperate-title{
    display: inline-block;
    font-size:32px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(73,145,201,1);
    line-height:45px;
  }
  .home-cooperate-more{
    display: inline-block;
    float: right;
    margin-top: 12px;
    font-size:24px;
    font-family:PingFangSC-Light,sans-serif;
    font-weight:300;
    color:rgba(79,76,77,1);
    line-height:33px;
  }
  .home-cooperate-line{
    margin-top: 8px;
    height:1px;
    background:rgba(240,240,240,1);
  }
  .home-cooperate-list{
    margin-top: 10px;
    margin-left: -15px;
    margin-right: -15px;
    margin-bottom: 60px;
  }
  .home-cooperate-img-div{
    width: 255px;
    height: 90px;
    margin: 30px 15px 0px 15px;
    padding: 15px 0;
    display: inline-block;
    text-align: center;
  }
  .home-cooperate-img{
    max-width: 220px;
    height: 60px;
  }

</style>
